// @flow
import { APICore } from "./apiCore";

const api = new APICore();

// account
function ApiGetAllTerapis(params: any): any {
  const baseUrl = "/api/admin/terapis";
  return api.get(`${baseUrl}`, params);
}

function ApiGetReportTerapis(params: any): any {
  const baseUrl = "/api/admin/transaksireflexy";
  return api.get(`${baseUrl}`, params);
}

function ApiPostTerapis(params: any): any {
  const baseUrl = "/api/admin/terapis";
  return api.create(`${baseUrl}`, params);
}
function ApiEditTerapis(params: any, id: any): any {
  const baseUrl = "/api/admin/terapis/" + id;
  return api.update(`${baseUrl}`, params);
}
function ApiDeleteTerapis(id: any): any {
  const baseUrl = "/api/admin/terapis/" + id;
  return api.delete(`${baseUrl}`);
}

export {
  ApiGetAllTerapis,
  ApiGetReportTerapis,
  ApiPostTerapis,
  ApiEditTerapis,
  ApiDeleteTerapis,
};
